import { render, staticRenderFns } from "./EchartsScatterChart.vue?vue&type=template&id=2a24f4cb&"
import script from "./EchartsScatterChart.vue?vue&type=script&lang=js&"
export * from "./EchartsScatterChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports